// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Array_NonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data_Array_NonEmpty_Internal from "../Data.Array.NonEmpty.Internal/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var bind = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity));
var pure = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity));
var wrap = /* #__PURE__ */ Data_Newtype.wrap();
var fail = /* #__PURE__ */ Foreign.fail(Data_Identity.monadIdentity);
var NonEmptyArray = function (x) {
    return x;
};
var udecodeNonEmptyArray = function (dictDecode) {
    return Unscramble.decodeNonEmptyArray(dictDecode);
};
var showNonEmptyArray = function (dictShow) {
    return Data_Array_NonEmpty_Internal.showNonEmptyArray(dictShow);
};
var ordNonEmptyArray = function (dictOrd) {
    return Data_Array_NonEmpty_Internal.ordNonEmptyArray(dictOrd);
};
var newtypeNonEmptyArray = {
    Coercible0: function () {
        return undefined;
    }
};
var functorNonEmptyArray = Data_Array_NonEmpty_Internal.functorNonEmptyArray;
var foldableNonEmptyArray = Data_Array_NonEmpty_Internal.foldableNonEmptyArray;
var foldable1NonEmptyArray = Data_Array_NonEmpty_Internal.foldable1NonEmptyArray;
var eqNonEmptyArray = function (dictEq) {
    return Data_Array_NonEmpty_Internal.eqNonEmptyArray(dictEq);
};
var encodeNonEmptyArray = function (dictEncode) {
    return {
        encode: (function () {
            var $26 = Foreign_Generic_Class.encode(Foreign_Generic_Class.arrayEncode(dictEncode));
            return function ($27) {
                return $26(Data_Array_NonEmpty.toArray(unwrap($27)));
            };
        })()
    };
};
var decodeNonEmptyArray = function (dictDecode) {
    var decode = Foreign_Generic_Class.decode(Foreign_Generic_Class.arrayDecode(dictDecode));
    return {
        decode: function (value) {
            return bind(decode(value))(function (arr) {
                var v = Data_Array_NonEmpty.fromArray(arr);
                if (v instanceof Data_Maybe.Just) {
                    return pure(wrap(v.value0));
                };
                if (v instanceof Data_Maybe.Nothing) {
                    return fail(new Foreign.ForeignError("Expected non empty array."));
                };
                throw new Error("Failed pattern match at Data.Array.NonEmpty.Serialized (line 28, column 5 - line 30, column 71): " + [ v.constructor.name ]);
            });
        }
    };
};
export {
    NonEmptyArray,
    newtypeNonEmptyArray,
    functorNonEmptyArray,
    eqNonEmptyArray,
    showNonEmptyArray,
    ordNonEmptyArray,
    udecodeNonEmptyArray,
    foldable1NonEmptyArray,
    foldableNonEmptyArray,
    encodeNonEmptyArray,
    decodeNonEmptyArray
};
